import classNames from 'classnames'
import React from 'react'
import PauseIcon from '../assets/icons/pause.svg'
import { VideoButton, VideoButtonSize } from './VideoButton'

export interface PauseButtonProps {
  additionalClassName?: string
  onClick: () => void
  size?: VideoButtonSize
}

export const PauseButton = ({ additionalClassName, onClick, size }: PauseButtonProps) => (
  <VideoButton
    additionalClassName={additionalClassName}
    onClick={onClick}
    title="Pause"
    size={size}
  >
    <PauseIcon
      className={classNames({
        'h-10 w-10': size === 'small',
        'h-20 w-20': size === 'big',
      })}
    />
  </VideoButton>
)
